import type { FilterPreset } from '../../shared/hooks/useFilterPresets';

/**
 * Pre-defined filter presets for the Manufacturers page.
 *
 * Each preset maps to a named {@link FilterPreset} that the user can apply
 * with a single click via the preset UI.
 */
export const MANUFACTURER_PRESETS: FilterPreset[] = [
  {
    id: 'mfr_default',
    label: 'Default',
    description: 'Manufacturers with at least one product',
    query: {
      groupOperator: 'AND',
      filterGroups: [
        {
          id: 'mfr_default_grp',
          logicalOperator: 'AND',
          rules: [
            {
              id: 'mfr_default_rule',
              field: 'product_count',
              operator: 'greaterThan',
              value: 0,
            },
          ],
        },
      ],
    },
  },
  {
    id: 'mfr_all',
    label: 'All Manufacturers',
    description: 'Show all manufacturers with no filters applied',
    query: {
      groupOperator: 'AND',
      filterGroups: [],
    },
  },
];
